import React from 'react'

export const resourceColumns = (layout, role, handleEdit) => [
	{
		name: 'Topic',
		selector: (row) => row.pname || 'N/A',
		sortable: true,
		width: '15%'
	},
	{
		name: 'How to use it',
		selector: (row) => row.howuse || 'N/A',
		sortable: true,
		width: '25%',
		cell: (row) => (
			<div>
				{row.link1 ? (
					<a href={row.link1} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
						{row.howuse || 'N/A'}
					</a>
				) : (
					row.howuse || 'N/A'
				)}
			</div>
		)
	},
	{
		name: 'Grade',
		selector: (row) => row.grade || 'N/A',
		sortable: true,
		width: '10%'
	},
	{
		name: 'Date',
		selector: (row) => row.rdate || 'N/A',
		sortable: true,
		width: '10%'
	},
	{
		name: 'Instructor',
		selector: (row) => (row.name && row.surname ? `${row.name} ${row.surname}` : 'N/A'),
		sortable: true,
		width: '15%'
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '25%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<button onClick={() => handleEdit(row)} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</button>
				{row.onDelete && (
					<button className="btn btn-danger btn-sm" onClick={row.onDelete}>
						 <i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
